/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * wallet object
 * @export
 * @interface GetCorporationsCorporationIdDivisionsWalletWallet
 */
export interface GetCorporationsCorporationIdDivisionsWalletWallet {
    /**
     * division integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdDivisionsWalletWallet
     */
    division?: number;
    /**
     * name string
     * @type {string}
     * @memberof GetCorporationsCorporationIdDivisionsWalletWallet
     */
    name?: string;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdDivisionsWalletWallet interface.
 */
export function instanceOfGetCorporationsCorporationIdDivisionsWalletWallet(value: object): value is GetCorporationsCorporationIdDivisionsWalletWallet {
    return true;
}

export function GetCorporationsCorporationIdDivisionsWalletWalletFromJSON(json: any): GetCorporationsCorporationIdDivisionsWalletWallet {
    return GetCorporationsCorporationIdDivisionsWalletWalletFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdDivisionsWalletWalletFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdDivisionsWalletWallet {
    if (json == null) {
        return json;
    }
    return {
        
        'division': json['division'] == null ? undefined : json['division'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function GetCorporationsCorporationIdDivisionsWalletWalletToJSON(json: any): GetCorporationsCorporationIdDivisionsWalletWallet {
    return GetCorporationsCorporationIdDivisionsWalletWalletToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdDivisionsWalletWalletToJSONTyped(value?: GetCorporationsCorporationIdDivisionsWalletWallet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'division': value['division'],
        'name': value['name'],
    };
}

